<mat-checkbox color="primary" class="dh-checkbox" name="{{label}}" [(ngModel)]="value" [disabled]="isDisabled">
  <span class="dh-check-box-label label-size">{{label}}</span>
</mat-checkbox>
